var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsBusinessCentral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n      }\r\n\r\n      .st1 {\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .st2 {\r\n        fill: url(#linear-gradient2);\r\n      }\r\n\r\n      .st3 {\r\n        fill: url(#linear-gradient1);\r\n      }\r\n\r\n      .st4 {\r\n        fill: url(#linear-gradient3);\r\n      }\r\n\r\n      .st5 {\r\n        fill: url(#linear-gradient6);\r\n      }\r\n\r\n      .st6 {\r\n        fill: url(#linear-gradient5);\r\n      }\r\n\r\n      .st7 {\r\n        fill: url(#linear-gradient4);\r\n      }\r\n\r\n      .st8 {\r\n        fill: #041818;\r\n      }\r\n\r\n      .st9 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .st10 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .st11 {\r\n        mask: url(#mask-1);\r\n      }\r\n\r\n      .st12 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st13 {\r\n        fill: url(#radial-gradient1);\r\n      }\r\n\r\n      .st14 {\r\n        fill: url(#radial-gradient3);\r\n      }\r\n\r\n      .st15 {\r\n        fill: url(#radial-gradient2);\r\n      }\r\n\r\n      .st16 {\r\n        fill: url(#radial-gradient4);\r\n      }\r\n\r\n      .st17 {\r\n        clip-path: url(#clippath);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 23.6,
    y: 6.3,
    width: 115,
    height: 115
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 23.6,
    y: 6.3,
    width: 115,
    height: 115,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1",
    "data-name": "mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_195_7986"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.6,6.3H23.6v115h115V6.3Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 23.6,
    y: 6.3,
    width: 115,
    height: 115,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-11",
    "data-name": "mask-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1_195_7986"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.6,6.3H23.6v115h115V6.3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 58.3,
    y1: 2221.2,
    x2: 102.6,
    y2: 2239.8,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c74a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1384b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16bbda"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -1254.3,
    cy: 772.2,
    fx: -1254.3,
    fy: 772.2,
    r: 0.9,
    gradientTransform: "translate(-30865.5 -50195) rotate(-90) scale(40.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0057aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1384b1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 84.8,
    y1: 2229.1,
    x2: 57.8,
    y2: 2241.1,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1384b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004695"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 105.4,
    y1: 2303.1,
    x2: 58.1,
    y2: 2292.9,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06517b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#09638e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c74a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 86.8,
    y1: 2296.5,
    x2: 106.5,
    y2: 2291.7,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09638e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: -1191.7,
    cy: 728.6,
    fx: -1191.7,
    fy: 728.6,
    r: 0.9,
    gradientTransform: "translate(35718 58339.7) rotate(90) scale(48.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#003580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09638e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 80.8,
    y1: 2242.1,
    x2: 81.4,
    y2: 2288.8,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43e5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#26cfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1384b1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: -1188.2,
    cy: 726.3,
    fx: -1188.2,
    fy: 726.3,
    r: 0.9,
    gradientTransform: "translate(31669.1 51703.5) rotate(90) scale(43.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#09638e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119fc5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: -1190.1,
    cy: 727.4,
    fx: -1190.1,
    fy: 727.4,
    r: 0.9,
    gradientTransform: "translate(33636.4 55021.6) rotate(90) scale(46.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#09638e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119fc5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 39.5,
    y1: 2239.5,
    x2: 74.2,
    y2: 2274.2,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6f6c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#43e5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26cfe8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: -1192.5,
    cy: 743.3,
    fx: -1192.5,
    fy: 743.3,
    r: 0.9,
    gradientTransform: "translate(71156.2 46843.3) rotate(65.4) scale(60.5 60.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2bdabe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119fc5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 87.7,
    y1: 2254.1,
    x2: 123,
    y2: 2289.5,
    gradientTransform: "translate(0 -2200.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ff2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2bdabe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#16bbda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1384b1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.3,47c9.3,9.3,24.3,9.3,33.5,0,9.3-9.3,9.3-24.3,0-33.5s-24.3-9.3-33.5,0c-9.3,9.3-9.3,24.3,0,33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M64.3,47c9.3,9.3,24.3,9.3,33.5,0,9.3-9.3,9.3-24.3,0-33.5s-24.3-9.3-33.5,0c-9.3,9.3-9.3,24.3,0,33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,47c9.3,9.3,24.3,9.3,33.5,0,9.3-9.3,9.3-24.3,0-33.5s-24.3-9.3-33.5,0c-9.3,9.3-9.3,24.3,0,33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.9,80.6c-9.3-9.3-24.3-9.3-33.5,0-9.3,9.3-9.3,24.3,0,33.5s24.3,9.3,33.5,0c9.3-9.3,9.3-24.3,0-33.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.9,80.6c-9.3-9.3-24.3-9.3-33.5,0-9.3,9.3-9.3,24.3,0,33.5s24.3,9.3,33.5,0c9.3-9.3,9.3-24.3,0-33.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.9,80.6c-9.3-9.3-24.3-9.3-33.5,0-9.3,9.3-9.3,24.3,0,33.5s24.3,9.3,33.5,0c9.3-9.3,9.3-24.3,0-33.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M64.3,80.6c9.3,9.3,24.3,9.3,33.5,0,9.3-9.3,9.3-24.3,0-33.5s-24.3-9.3-33.5,0c-9.3,9.3-9.3,24.3,0,33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.3,80.6c9.3,9.3,24.3,9.3,33.5,0,9.3-9.3,9.3-24.3,0-33.5s-24.3-9.3-33.5,0c-9.3,9.3-9.3,24.3,0,33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.3,80.6c9.3,9.3,24.3,9.3,33.5,0,9.3-9.3,9.3-24.3,0-33.5s-24.3-9.3-33.5,0c-9.3,9.3-9.3,24.3,0,33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.8,47L64.3,13.5c-9.3,9.3-9.3,24.3,0,33.5s9.3,24.3,0,33.5-24.3,9.3-33.5,0-9.3-24.3,0-33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.8,47L64.3,13.5c-9.3,9.3-9.3,24.3,0,33.5s9.3,24.3,0,33.5-24.3,9.3-33.5,0-9.3-24.3,0-33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.4,80.6l-33.5,33.5c9.3-9.3,9.3-24.3,0-33.5-9.3-9.3-9.3-24.3,0-33.5s24.3-9.3,33.5,0c9.3,9.3,9.3,24.3,0,33.5h0Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M174.8,53.7h-1.6v-8.9c0-.9,0-1.8.2-2.7-.2.6-.3,1.1-.5,1.3l-4.5,10.3h-.8l-4.5-10.2c-.3-.5-.3-.9-.5-1.4v11.6h-1.4v-13.4h1.9l4.1,9.2.6,1.6h.2c.2-.8.5-1.3.5-1.6l4.1-9.2h1.9v13.4h.2,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M178.4,41.7c-.3,0-.6-.2-.8-.3-.2-.2-.3-.5-.2-.6-.2-.5,0-.8.5-.9h.5c.3,0,.5,0,.6.2s.3.5.3.8c-.2.5-.5.9-1,.9h0ZM179.1,53.7h-1.6v-9.6h1.6v9.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.1,53.2c-.8.5-1.8.6-2.7.6s-2.4-.5-3.3-1.3c-.8-.9-1.3-2.2-1.3-3.5s.5-2.9,1.3-3.8c1.6-1.6,4-1.9,5.9-.9v1.6c-.6-.5-1.4-.8-2.4-.8s-1.8.3-2.4,1.1c-.6.8-1.1,1.8-1,2.7,0,.9.3,1.9,1,2.7.6.6,1.4.9,2.4.9s1.8-.3,2.4-.8v1.4h.2,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194.7,45.5l-1.1-.2c-.6,0-1.3.3-1.6.9-.5.8-.6,1.6-.6,2.6v4.9h-1.6v-9.6h1.6v1.9c.2-.6.5-1.1,1-1.6.5-.3,1-.5,1.6-.5h1l-.2,1.4h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M199.8,53.8c-1.3,0-2.5-.5-3.5-1.3-.8-.9-1.3-2.2-1.3-3.5-.2-1.4.3-2.7,1.3-3.8,1-.9,2.2-1.4,3.5-1.4s2.4.5,3.3,1.3c.8.9,1.3,2.4,1.3,3.7s-.5,2.7-1.3,3.7c-.8,1.1-2.1,1.6-3.3,1.4ZM199.9,45.2c-1,0-1.8.3-2.4.9-1.1,1.6-1.1,3.8,0,5.4.6.6,1.4,1.1,2.4.9.8,0,1.6-.3,2.2-.9,1.1-1.6,1.1-3.8,0-5.6-.5-.5-1.4-.9-2.2-.8h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M205.8,53.3v-1.6c.8.6,1.8.9,2.7.9s1.9-.5,1.9-1.3,0-.5-.2-.6l-.5-.5-.6-.3-.8-.3-1.3-.5-.8-.5c-.2-.2-.3-.5-.5-.8s-.2-.6-.2-.9.2-.8.3-1.1c.2-.3.5-.6,1-.9l1.1-.5,1.3-.2c.8,0,1.4.2,2.2.5v1.6c-.6-.5-1.4-.6-2.4-.6h-.8l-.6.2-.3.5c-.2.2-.2.3-.2.5s.2.5.2.6l.3.5.6.3,1,.3,1.1.5,1,.5c.3.2.5.5.5.8.2.3.2.6.2.9,0,.5-.2.8-.2,1.3-.2.3-.5.6-1,.9l-1.3.5-1.4.2c-.8-.3-1.6-.5-2.4-.8h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M217.7,53.8c-1.3,0-2.4-.5-3.3-1.3-1-.9-1.4-2.2-1.3-3.5-.2-1.4.3-2.7,1.3-3.8,1-.9,2.2-1.4,3.5-1.4s2.4.5,3.3,1.3c1,.9,1.3,2.4,1.3,3.7s-.3,2.6-1.3,3.7c-.8,1.1-2.1,1.6-3.5,1.4ZM217.9,45.2c-1,0-1.8.3-2.4.9-.6.8-1,1.8-1,2.7s.3,1.9,1,2.7c1.3,1.3,3.3,1.3,4.6.2,1.1-1.8,1.1-3.8,0-5.6-.5-.6-1.3-1.1-2.2-.9h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M229.2,40.9l-1.1-.2c-1,0-1.6.6-1.6,1.9v1.4h2.2v1.3h-2.2v8.3h-1.6v-8.3h-1.6v-1.3h1.6v-1.6c0-.8.3-1.8,1-2.4.6-.6,1.4-.9,2.2-.9l1.1.2v1.6h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.3,53.5c-.5.2-1,.3-1.4.3-1.6,0-2.5-.9-2.5-2.9v-5.6h-1.6v-1.3h1.6v-2.4l1.6-.5v2.7h2.4v1.3h-2.4v5.4c0,.5,0,.9.3,1.3s.6.5,1.1.5.6-.2,1-.3v1.4h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.5,53.7v-13.4h3.8c4.6,0,7,2.2,7,6.5.2,1.9-.6,3.7-1.9,4.9-1.4,1.3-3.3,1.9-5.2,1.9h-3.7ZM241.9,41.7v10.5h1.9c1.4.2,3-.3,4.1-1.4,1.1-.9,1.6-2.6,1.6-4,0-3.5-1.9-5.1-5.6-5.1,0,0-2.1,0-2.1,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.7,44.1l-4.5,11.1c-.8,1.9-1.9,3-3.3,3l-1-.2v-1.3l1,.2c.8,0,1.6-.6,1.8-1.4l.8-1.8-3.8-9.6h1.8l2.5,7.5c0,.2.2.3.2.8,0-.3.2-.5.2-.8l2.7-7.5h1.8v-.2h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M269.6,53.7h-1.6v-5.4c0-2.1-.8-3-2.2-3s-1.4.3-1.9.9c-.5.6-.8,1.4-.8,2.2v5.4h-1.6v-9.6h1.6v1.6c.6-1.1,1.9-1.9,3.2-1.9s1.8.5,2.4,1.1c.6.8,1,1.9,1,2.9v5.7h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M278.7,53.7h-1.6v-1.6c-.6,1.1-1.8,1.8-3,1.8s-1.6-.2-2.2-.8c-.5-.5-.8-1.3-.8-1.9,0-1.8,1-2.9,3-3l2.9-.5c0-1.6-.6-2.4-1.9-2.4s-2.4.5-3.2,1.3v-1.6c1-.6,2.1-.9,3.3-.9,2.2,0,3.3,1.3,3.3,3.7l.2,6.1h0ZM277.1,48.9l-2.2.3c-.6,0-1.1.3-1.6.5-.3.3-.6.8-.5,1.3,0,.5.2.8.5,1.1.3.3.8.5,1.3.5s1.4-.3,1.9-.8c.5-.6.6-1.3.6-1.9v-.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M294.4,53.7h-1.4v-5.6c0-.8-.2-1.6-.5-2.2-.3-.5-1-.8-1.6-.8s-1.3.3-1.6.9c-.5.6-.6,1.4-.6,2.2v5.4h-1.6v-5.6c0-1.9-.6-2.9-2.1-2.9s-1.3.3-1.6.9c-.5.6-.6,1.4-.6,2.2v5.4h-1.6v-9.6h1.6v1.6c.6-1.1,1.8-1.8,3-1.8s1.1.2,1.6.5.8.8,1,1.4c.6-1.3,1.9-2.1,3.2-1.9,2.1,0,3,1.3,3,4v5.6h-.2,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M297.6,41.7c-.5-.2-1-.5-1-.9s.2-.6.3-.8.5-.3.6-.2c.3,0,.6,0,.8.2.2.2.2.5.2.8s-.2.5-.2.6c-.3.2-.6.3-.8.3h0ZM298.3,53.7h-1.6v-9.6h1.6v9.6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M307.3,53.2c-.8.5-1.6.6-2.5.6s-2.4-.5-3.3-1.3c-.8-.9-1.3-2.2-1.3-3.5s.5-2.9,1.3-3.8c1-.9,2.2-1.4,3.5-1.4s1.6.2,2.4.5v1.6c-.6-.5-1.4-.8-2.4-.8s-1.9.3-2.4,1.1c-.6.8-1,1.8-1,2.7-.2.9.2,1.9,1,2.7.6.6,1.4.9,2.4.9s1.6-.3,2.4-.8v1.4h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M308.4,53.3v-1.6c.8.6,1.8.9,2.7.9,1.4,0,2.1-.5,2.1-1.3s-.2-.5-.2-.6c-.2-.2-.2-.3-.5-.5l-.6-.3-1-.3-1.1-.5-.8-.5c-.3-.2-.5-.5-.5-.8-.2-.3-.2-.6-.2-.9s.2-.8.2-1.1c.2-.3.5-.6,1-.9l1.3-.5,1.3-.2c.8,0,1.4.2,2.2.5v1.6c-.8-.5-1.6-.6-2.4-.6h-.8l-.5.2-.5.5c-.2.2-.2.3-.2.5s0,.5.2.6l.5.5.5.3,1,.3,1.1.5,1,.5c.3.2.5.5.5.8.3.6.3,1.6-.2,2.2-.2.3-.5.6-1,.9l-1.1.5-1.4.2c-.8-.3-1.8-.5-2.5-.8h0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M328.5,49.8c0,.6-.2,1.1-.3,1.6-.2.5-.6.9-1,1.3-.5.3-1,.6-1.4.8-.6.2-1.3.3-1.9.3-1.1,0-2.1-.2-3-.8v-1.6c1,.6,1.9.9,3,.9h1.3c.3-.2.8-.3,1-.5l.6-.8c.2-.3.2-.8.2-1.1,0-1.8-1.3-2.7-3.8-2.7h-1.1v-1.3h1c2.2,0,3.3-.8,3.3-2.4s-.8-2.2-2.5-2.2-1.9.3-2.7.9v-1.4c1-.5,2.1-.8,3-.8l1.6.2c.5.2.8.3,1.1.6.3.3.6.6.8.9.2.5.3.8.2,1.3.2,1.6-1,3-2.7,3.3.5,0,1,.2,1.3.3.3.2.8.3,1,.6l.6.9c.5.6.6,1.1.6,1.4h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M338.7,49.5c0,.6-.2,1.3-.3,1.8s-.5.9-1,1.4c-.3.3-.8.6-1.3.9-.5.3-1.1.3-1.6.3s-1.3-.2-1.8-.5c-.6-.3-1-.6-1.3-1.3-.5-.5-.8-1.1-1-1.9-.2-.8-.3-1.8-.3-2.6s.2-2.2.5-3.2c.2-.8.6-1.8,1.1-2.4.5-.6,1-1.1,1.6-1.6.8-.3,1.6-.5,2.4-.5s1.4.2,2.2.3v1.4c-.6-.3-1.4-.5-2.2-.5s-1.1.2-1.6.3c-.5.3-.8.6-1.3,1.1-.3.6-.6,1.1-.8,1.8-.2.8-.2,1.6-.2,2.4.6-1.1,1.8-1.8,3-1.6.5,0,1.1.2,1.6.3.5.2,1,.5,1.3.9.3.3.6.8.8,1.3v1.6h0ZM337.2,49.5c0-.5,0-.8-.2-1.3-.2-.3-.3-.6-.5-.9l-1-.5-1-.2-1.1.2-1,.5c-.2.3-.3.6-.5.9-.2.3-.2.6-.2.9,0,.5,0,.9.2,1.3s.3.8.5,1.1l1,.6,1.1.2c.3,0,.6,0,1-.2l1-.5c.2-.3.3-.6.5-.9.2-.3.2-.8.2-1.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M347.9,49.5c0,.6-.2,1.3-.3,1.8s-.5.9-1,1.3c-.5.5-1,.6-1.6.9-.6.2-1.3.3-1.9.3-1,0-1.9-.2-2.9-.5v-1.6c.8.6,1.9.9,2.9.9s1,0,1.3-.2l1-.5c.3-.3.5-.5.5-.9.2-.3.3-.8.2-1.3,0-.8-.3-1.6-1-2.1-.8-.5-1.6-.8-2.5-.6h-2.2l.5-6.7h6.2v1.3h-4.9l-.3,4h1.3c.6,0,1.3.2,1.9.3l1.4.8c.3.3.6.8,1,1.3.6.3.6.9.6,1.4h0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M161.2,88v-20.9h6.7c1.8-.2,3.3.3,4.8,1.3,1.1.8,1.8,2.1,1.8,3.5s-.3,2.2-1,3c-.6.9-1.6,1.6-2.7,1.9,1.3,0,2.5.6,3.5,1.6.8.9,1.3,2.2,1.3,3.5s-.8,3.3-2.1,4.3c-1.6,1.1-3.3,1.8-5.2,1.6l-7,.2h0ZM164.7,69.9v5.9h2.2c1.1.2,2.1-.2,2.9-.9.6-.6,1.1-1.4,1-2.4,0-1.9-1.3-2.7-3.5-2.7l-2.5.2h0ZM164.7,78.6v6.7h3c1.1,0,2.1-.3,3-.9.6-.6,1.1-1.6,1-2.4,0-2.2-1.4-3.3-4.5-3.3h-2.5,0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191.8,88h-3.5v-2.4c-1,1.8-2.7,2.7-4.6,2.7-3.5,0-5.2-2.1-5.2-6.4v-8.9h3.5v8.6c0,2.7,1,4,3,4s1.9-.3,2.4-1.1c.6-.8,1.1-1.8,1-2.9v-8.6h3.5v15h0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M195.3,87.6v-3c1.3.9,2.7,1.4,4.1,1.4s3-.6,3-1.9,0-.6-.2-.9l-.6-.5c-.3-.3-.6-.5-1.1-.5l-1.3-.5-1.6-.8-1.3-.9c-.3-.3-.6-.6-.8-1.1-.2-.5-.2-.9-.2-1.6s.2-1.3.5-1.9c.3-.5.8-1.1,1.3-1.4.6-.3,1.3-.6,1.9-.8s1.4-.3,2.2-.3c1.3,0,2.5.2,3.8.6v2.9c-1.1-.6-2.4-.9-3.7-.9h-1.3l-1,.3-.5.5c-.3.5-.3,1.1,0,1.6.2.2.3.5.6.5l1,.5,1.3.5,1.8.8,1.3.9.8,1.3c.2.5.3,1.1.3,1.6s-.2,1.4-.5,1.9c-.3.6-.8,1.1-1.4,1.3-.6.5-1.3.8-1.9.9l-2.4.2c-1.6.3-3,0-4.3-.5h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.7,70.1c-.5,0-1-.2-1.4-.5-.3-.3-.5-.8-.5-1.3s.2-1.1.5-1.4c.5-.3,1-.5,1.4-.5s1.1.2,1.4.5c.5.3.6.9.6,1.4s-.3.9-.6,1.3-1,.5-1.4.5ZM212.3,88h-3.3v-15h3.3v15Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M230,88h-3.3v-8.4c0-2.7-1-4.1-3-4.1s-1.9.5-2.5,1.3c-.6.8-1,1.8-1,2.9v8.4h-3.5v-15h3.5v2.6c1-1.8,2.9-2.9,4.9-2.9s2.9.5,3.8,1.6c.8,1.4,1.3,3,1.3,4.6v9.1h-.2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.9,81.5h-10.2c0,1.1.3,2.4,1.3,3.2,1,.8,2.1,1.1,3.3,1.1s3.2-.5,4.5-1.4v2.7c-1.6.8-3.5,1.3-5.4,1.3-1.9.2-3.8-.6-5.1-1.9-1.4-1.6-2.1-3.7-1.9-5.7-.2-2.1.6-4.1,1.9-5.6,1.3-1.4,3.2-2.2,5.2-2.2,1.8-.2,3.5.6,4.6,1.9,1.3,1.6,1.9,3.5,1.8,5.4v1.3h0ZM243.5,79.1c0-.9-.3-1.9-1-2.7-.6-.6-1.4-1.1-2.4-.9-1,0-1.8.3-2.4.9-.6.8-1.1,1.8-1.3,2.7h7Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.1,87.6v-3c1.3.9,2.7,1.4,4.1,1.4s3-.6,3-1.9-.2-.6-.3-.9c-.2-.3-.3-.5-.6-.5-.3-.3-.6-.5-1.1-.5l-1.3-.5-1.6-.8-1.3-.9c-.3-.3-.5-.6-.6-1.1-.2-.5-.3-.9-.3-1.6s.2-1.3.5-1.9c.3-.5.8-1.1,1.3-1.4.6-.3,1.3-.6,1.9-.8s1.4-.3,2.2-.3c1.3,0,2.5.2,3.8.6v2.9c-1.1-.6-2.4-.9-3.7-.9h-1.1l-1,.3c-.2.2-.5.3-.5.5-.3.5-.3,1.1,0,1.6.2.2.3.5.5.5l1,.5,1.3.5,1.8.8,1.3.9c.3.3.6.8.8,1.3.3.5.3,1.1.3,1.6,0,1.4-.6,2.6-1.9,3.3-.6.5-1.4.6-2.1.9l-2.4.2c-1.1.2-2.7-.2-4-.6h0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M261.8,87.6v-3c1.3.9,2.7,1.4,4.1,1.4,2.1,0,3-.6,3-1.9s-.2-.6-.3-.9c-.2-.3-.3-.5-.6-.5l-1-.5-1.4-.5-1.6-.8-1.3-.9c-.3-.3-.5-.6-.6-1.1-.2-.5-.3-.9-.2-1.6,0-.6.2-1.3.5-1.9s.8-1.1,1.4-1.4c.6-.3,1.3-.6,1.9-.8.8-.2,1.6-.3,2.4-.3,1.3,0,2.5.2,3.7.6v2.9c-1.1-.6-2.4-1.1-3.7-.9h-1.1l-1,.3c-.2.2-.5.3-.5.5-.3.5-.3,1.1,0,1.6.2.2.3.5.5.5l1,.5,1.3.5,1.6.8,1.3.9c.3.3.6.8,1,1.3.2.5.2,1.1.2,1.6s-.2,1.4-.5,1.9c-.3.5-.8.9-1.3,1.3-.6.3-1.3.6-1.9.9l-2.4.2c-1.6.3-3,0-4.5-.5h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M298.7,87.1c-1.9.8-3.8,1.3-5.9,1.3-2.7.2-5.4-.9-7.3-2.9-1.8-2.1-2.7-4.8-2.7-7.5-.2-3,1-5.9,3-8.1,2.1-2.1,4.8-3.2,7.8-3,1.8,0,3.3.3,4.9.9v3.5c-1.4-.8-3-1.3-4.6-1.3-2.1-.2-4,.6-5.6,2.1-1.4,1.6-2.2,3.7-2.1,5.9-.2,2.1.6,4,1.9,5.4,1.3,1.4,3.2,2.2,5.2,2.1,1.8,0,3.5-.5,5.1-1.4v3h.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M315,81.5h-10.2c0,1.1.3,2.4,1.3,3.2,1,.8,2.2,1.1,3.5,1.1s3-.5,4.3-1.4v2.7c-1.6.8-3.5,1.3-5.2,1.3-1.9.2-3.8-.6-5.2-1.9-1.3-1.6-1.9-3.7-1.9-5.7-.2-2.1.6-4.1,2.1-5.6,1.3-1.4,3.2-2.2,5.1-2.2,1.8-.2,3.5.6,4.8,1.9,1.1,1.6,1.8,3.5,1.6,5.4v1.3h0ZM311.6,79.1c.2-.9-.2-1.9-.8-2.7-.6-.6-1.6-.9-2.4-.9s-1.8.3-2.4.9c-.6.8-1.1,1.8-1.3,2.7h6.9Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M331.5,88h-3.5v-8.4c0-2.7-1-4.1-2.9-4.1s-1.9.5-2.5,1.3c-.6.8-1,1.8-1,2.9v8.4h-3.5v-15h3.5v2.6c1-1.8,2.9-2.9,4.9-2.9,1.4-.2,2.7.5,3.7,1.6,1,1.3,1.4,3,1.3,4.6v9.1h0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M343.5,87.9c-.8.3-1.6.5-2.5.5-2.9,0-4.3-1.4-4.3-4.1v-8.4h-2.5v-2.7h2.5v-3.5l3.3-.9v4.5h3.5v2.7h-3.5v7.5c0,.6.2,1.3.5,1.9.5.3,1.1.6,1.6.5.5,0,1.1-.2,1.4-.5v2.7h0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M354.9,76.3c-.5-.3-1.1-.5-1.8-.5-1,0-1.9.5-2.5,1.3-.8,1.1-1.1,2.4-1,3.8v7h-3.3v-15h3.3v3h.2c.2-.9.8-1.8,1.4-2.4.6-.6,1.4-.9,2.4-.9l1.4.2-.2,3.5h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M368.8,88h-3.3v-2.4c-1,1.8-2.7,2.7-4.5,2.7-1.3.2-2.5-.3-3.5-1.3-1-.8-1.4-1.9-1.3-3,0-2.9,1.6-4.5,4.9-4.9l4.5-.5c0-2.2-1-3.2-3-3.2s-3.5.6-4.8,1.8v-2.9c1.6-.9,3.5-1.4,5.4-1.4,3.8,0,5.6,1.9,5.6,5.6v9.6h0ZM365.4,80.7l-3,.5c-.8,0-1.6.3-2.2.6-.5.5-.8,1.1-.6,1.9,0,.6.3,1.1.6,1.6.5.3,1.1.6,1.8.5,1,0,1.9-.3,2.5-1.1.6-.8,1-1.8,1-2.7v-1.3h0Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M376.4,65.9h-3.5v22.1h3.5v-22.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsBusinessCentral);
export default __webpack_public_path__ + "static/media/MS-BusinessCentral.b996f492c9167849289c66408992031b.svg";
export { ForwardRef as ReactComponent };